export default __webpack_public_path__ + "static/media/img-0274-malta-full-face.7e693158.png";